import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import {db} from '../firebase';
import {Link} from 'react-router-dom';

class StreetTeamPipeline extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: null,
      isLoading: true,
    }
  }

  componentDidMount = () =>{
    this.loadUsers();
  }

  loadUsers = () => {
    db
      .collection('users')
      .where("streetTeamOnboardingStarted", "==", true)
      .onSnapshot((querySnapshot) => {
        this.setState({
          isLoading: false,
          users: querySnapshot.docs,
        })
      });
  }

  exportToCsv = () => {
    let csvContent = 'data:text/csv;charset=utf-8,'
    csvContent += 'User ID,Email,Name,Signed Up,Last Signed In,Phone Number,Market,Onboarding Started,Street Team Enabled,Stripe Id\n'
    this.state.users.forEach((user) => {
      const {id: userId} = user;
      const {
        streetTeamOnboardingStarted,
        streetTeam,
        stripeConnectAccountId,
        streetTeamMarket,
        streetTeamPhone,
        email,
        displayName,
        creationTime,
        lastSeenAt
      } = user.data();
      const creationTimeData = creationTime && moment(new Date(creationTime)).format("YYYY-MM-DD HH:mm")
      const lastSeenAtData = lastSeenAt && moment(new Date(lastSeenAt)).format("YYYY-MM-DD HH:mm")
      let row = `${userId},${email},${displayName},${creationTimeData},${lastSeenAtData},${streetTeamPhone},${streetTeamMarket}`
      row += `,${JSON.stringify(streetTeamOnboardingStarted)},${JSON.stringify(streetTeam)},${stripeConnectAccountId}`
      csvContent += row + '\n'
    })
    const encodedUri = encodeURI(csvContent)
    const link = document.createElement('a')
    link.setAttribute('href', csvContent)
    link.setAttribute('download', 'streetTeamPipeline.csv')
    link.click()
  }

  render() {
    const {isLoading, users} = this.state;

    if (isLoading) {
      return (
        <div>
          Loading...
        </div>
      )
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col">
            <h1>Pipeline</h1>

            <div className='table-responsive my-2'>
              <table className='table'>
                <thead>
                  <tr>
                    <td>User ID</td>    
                    <td>Email</td>
                    <td>Name</td>
                    <td>Signed Up</td>
                    <td>Last Signed In</td>
                    <td>Phone Number</td>
                    <td>Market</td>
                    <td>Onboarding Started</td>
                    <td>Street Team Enabled</td>
                    <td>Stripe ID</td>
                  </tr>
                </thead>

                <tbody>
                  {users.map((user) => {
                    const {id: userId} = user;
                    const {
                      streetTeamOnboardingStarted, streetTeam, stripeConnectAccountId, streetTeamMarket,
                      streetTeamPhone, email, displayName, creationTime, lastSeenAt
                    } = user.data();

                    const streetTeamOnboardingStartedJson = JSON.stringify(streetTeamOnboardingStarted)
                    const streetTeamJson = JSON.stringify(streetTeam)

                    return (
                      <tr key={userId}>
                        <th scope="row">
                          <Link to={`/users/${userId}`}>
                            {userId}
                          </Link>
                        </th>
                        <td>{email}</td>
                        <td>{displayName}</td>
                        <td>{creationTime && moment(new Date(creationTime)).format("YYYY-MM-DD HH:mm")}</td>
                        <td>{lastSeenAt && moment(new Date(lastSeenAt)).format("YYYY-MM-DD HH:mm")}</td>
                        <td>{streetTeamPhone}</td>
                        <td>{streetTeamMarket}</td>
                        <td>{streetTeamOnboardingStarted ? streetTeamOnboardingStarted : false}</td>
                        <td>{streetTeamJson ? streetTeamJson : 'false'}</td>
                        <td>
                          <a href={`https://dashboard.stripe.com/applications/users/${stripeConnectAccountId}`}>
                            {stripeConnectAccountId}
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {this.state.lastVisible !== undefined &&
              <button type="button"
                      className="btn btn-primary"
                      onClick={async () => await this.loadMoreUsers()}
              >Load More</button>
            }
            <button type="button"
                    className="btn btn-danger"
                    onClick={() => this.loadAllUsers()}
            >Export CSV</button>
          </div>
        </div>
      </div>
    )
  }
}

StreetTeamPipeline.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

export {StreetTeamPipeline};



// WEBPACK FOOTER //
// ./src/street-team/StreetTeamPipeline.js